/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FraudOverrideRestrictionRequest
 */
export interface FraudOverrideRestrictionRequest {
    /**
     * 
     * @type {string}
     * @memberof FraudOverrideRestrictionRequest
     */
    note: string;
}

/**
 * Check if a given object implements the FraudOverrideRestrictionRequest interface.
 */
export function instanceOfFraudOverrideRestrictionRequest(value: object): value is FraudOverrideRestrictionRequest {
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function FraudOverrideRestrictionRequestFromJSON(json: any): FraudOverrideRestrictionRequest {
    return FraudOverrideRestrictionRequestFromJSONTyped(json, false);
}

export function FraudOverrideRestrictionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FraudOverrideRestrictionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'note': json['note'],
    };
}

export function FraudOverrideRestrictionRequestToJSON(value?: FraudOverrideRestrictionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'note': value['note'],
    };
}

